<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="container">
      <div style="padding: 20px">
        <div class="searchbox">
          <div class="item">
            <span>患者姓名</span>
            <el-input
              placeholder="请输入"
              v-model="patient_name"
              style="width: 120px; margin-left: 12px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 120px; margin-left: 12px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生手机号</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_phone"
              style="width: 120px; margin-left: 12px"
              clearable
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span>云诊所名称</span>
            <el-input
              placeholder="请输入"
              v-model="org_name"
              style="width: 200px; margin-left: 12px"
              clearable
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span style="margin-right: 8px">申请药房</span>
            <!-- <el-input placeholder="请输入"
                      v-model="f_hospital"
                      style="width: 200px; margin-left: 12px"
                      clearable
                      @input="search"></el-input> -->
            <myInputSerch v-model="f_hospital" @update="search"></myInputSerch>
          </div>
          <div class="item">
            <span style="margin-right: 8px">目标药房</span>
            <!-- <el-input
              placeholder="请输入"
              v-model="re_hospital"
              style="width: 200px; margin-left: 12px"
              clearable
              @input="search"
            ></el-input> -->
            <myInputSerch v-model="re_hospital" @update="search"></myInputSerch>
          </div>
          <div class="item">
            <span>开方时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="search"
              clearable
              style="width: 225px; margin-left: 12px"
            ></el-date-picker>
          </div>
          <div class="item">
            <span>来源</span>
            <el-select
              v-model="pre_type"
              placeholder="请选择"
              style="width: 260px; margin-left: 12px"
              multiple
              clearable
              @change="search"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>药品剂型</span>
            <el-select
              v-model="drug_type"
              placeholder="请选择"
              style="width: 150px; margin-left: 12px"
              clearable
              @change="search"
            >
              <el-option
                v-for="item in options2"
                :key="item.drug_type"
                :label="item.drug_type_name"
                :value="item.drug_type"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>处方状态</span>
            <el-select
              v-model="status"
              placeholder="请选择"
              style="width: 150px; margin-left: 12px"
              clearable
              @change="search"
            >
              <el-option
                v-for="item in status_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span style="margin-right: 10px">是否代煎</span>
            <el-radio-group v-model="drug_machining" @change="search">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">代煎</el-radio>
              <el-radio :label="2">自煎</el-radio>
            </el-radio-group>
          </div>

          <div class="item">
            <span>处方号</span>
            <el-input
              placeholder="请输入"
              v-model="pre_id"
              style="width: 120px; margin-left: 12px"
              @input="search"
              clearable
            ></el-input>
          </div>

          <div class="item">
            <span>是否隐藏剂量</span>
            <el-select
              v-model="is_show"
              placeholder="请选择"
              style="width: 150px; margin-left: 12px"
              clearable
              @change="search"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              type="info"
              size="medium"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 10px;
              "
              @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="开方时间"
              prop="create_time"
            ></el-table-column>

            <el-table-column label="处方号" prop="pre_id"></el-table-column>

            <el-table-column label="患者信息">
              <template slot-scope="scope">
                <div>{{ scope.row.user_name }}</div>
                <div>
                  <span v-if="scope.row.patient_sex == 1">男</span>
                  <span v-if="scope.row.patient_sex == 2">女</span>
                  <span style="margin-left: 10px">{{ scope.row.age }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="科室"
              prop="department_name"
            ></el-table-column>
            <el-table-column label="医生信息" width="108">
              <template slot-scope="scope">
                <div
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor: pointer"
                >
                  {{ scope.row.doctor_name }}
                </div>
                <div>
                  <span v-if="scope.row.d_sex == 1">男</span>
                  <span v-if="scope.row.d_sex == 2">女</span>
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </div>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column label="药品剂型">
              <template slot-scope="scope">
                <div>{{ scope.row.drug_type_name }}</div>
                <p v-if="scope.row.drug_machining">代煎</p>
              </template>
            </el-table-column>
            <el-table-column label="是否隐藏剂量" width="105">
              <template slot-scope="scope">
                <span>{{ scope.row.is_show == 1 ? "否" : "是" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="处方状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待取药</span>
                <span v-if="scope.row.status == 2">待审方</span>
                <span v-if="scope.row.status == 3">审核已通过</span>
                <span v-if="scope.row.status == 4">已抓药</span>
                <span v-if="scope.row.status == 5">过期未取药</span>
                <span v-if="scope.row.status == 6">审方不通过</span>
                <span v-if="scope.row.status == 7">医生作废</span>
                <span v-if="scope.row.status == 8">平台退款</span>
              </template>
            </el-table-column>
            <el-table-column label="处方来源">
              <template slot-scope="scope">
                <span v-if="scope.row.pre_type == 1">问诊开方</span>
                <span v-if="scope.row.pre_type == 2">直接开方</span>
                <span v-if="scope.row.pre_type == 4">云诊所开方</span>
                <span v-if="scope.row.pre_type == 5">手机号开方</span>
                <span v-if="scope.row.pre_type == 6">微信开方</span>
                <span v-if="scope.row.pre_type == 7">视频问诊开方</span>
                <span v-if="scope.row.pre_type == 8">按方购药</span>
                <span v-if="scope.row.pre_type == 9">拍方购药</span>
                <div>{{ scope.row.org_name }}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="申请时间"
                             prop="f_time"></el-table-column> -->
            <el-table-column
              label="申请药房"
              prop="hospital_name"
            ></el-table-column>
            <el-table-column
              label="转单原因"
              prop="return_desc"
            ></el-table-column>
            <el-table-column
              label="目标药房"
              prop="rhospital_name"
            ></el-table-column>
            <el-table-column label="分配时间" prop="f_time"></el-table-column>
            <el-table-column
              label="操作人"
              prop="action_name"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="toDetail(scope.row.pre_id)"
                  >查看处方</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 24px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import myInputSerch from "@/components/myInputSerch";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      date: [],
      totalNum: 0,
      patient_name: "",
      doctor_name: "",
      doctor_phone: "",
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      pre_type: [],
      drug_type: "",
      org_name: "",
      is_show: "",
      pre_id: "",

      re_hospital: "",
      f_hospital: "",
      drug_machining: 0,
      status: 0,
      options: [
        {
          value: 1,
          label: "问诊开方",
        },
        {
          value: 2,
          label: "直接开方",
        },
        {
          value: 4,
          label: "云诊所开方",
        },
        {
          value: 5,
          label: "手机号开方",
        },
        {
          value: 6,
          label: "微信开方",
        },
        {
          value: 7,
          label: "视频问诊开方",
        },
        {
          value: 8,
          label: "按方购药",
        },
        {
          value: 9,
          label: "拍方购药",
        },
      ],
      options2: [],
      options3: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "是",
        },
        {
          value: 1,
          label: "否",
        },
      ],
      status_list: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "待取药",
        },
        {
          value: 2,
          label: "待审方",
        },
        {
          value: 3,
          label: "已通过",
        },
        {
          value: 4,
          label: "已抓药",
        },
        {
          value: 5,
          label: "过期未取药",
        },
        {
          value: 6,
          label: "审方不通过",
        },
        {
          value: 7,
          label: "医生手动作废",
        },
        {
          value: 8,
          label: "平台退款",
        },
      ],
      item: {},
      doc_msg: false,
      doctorId: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
  },
  components: {
    DocMsg,
    myInputSerch,
  },
  created() {
    this.getDrugTypeList();
  },
  activated() {
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取处方列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        user_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        pre_type: this.pre_type.toString(),
        drug_type: this.drug_type,
        org_name: this.org_name,
        is_show: this.is_show,
        pre_id: this.pre_id,
        is_return: 2,
        status: this.status,
        drug_machining: this.drug_machining,
        re_hospital: this.re_hospital,
        f_hospital: this.f_hospital,
      };
      if (this.date && this.date.length > 0) {
        data.create_start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios.post("platform/Order/getReturnOrder", data).then((res) => {
        if (!res.data.list.length && this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          this.getList();
        }
        this.tableData = res.data.list.map((item) => {
          item.create_time = dayjs
            .unix(item.create_time)
            .format("YYYY-MM-DD HH:mm");
          if (item.f_time) {
            item.f_time = dayjs.unix(item.f_time).format("YYYY-MM-DD HH:mm");
          }
          return item;
        });
        this.totalNum = res.data.total;
      });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.options2 = res.data.list;
        });
    },
    //查看详情
    toDetail(pre_id) {
      this.$router.push({
        path: "chufangdetail",
        query: {
          pre_id,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 200px);
}
.noneline {
  border: 0;
  padding: 0 20px;
}
.title {
  font-size: 16px;
  width: 90px;
}
.mydivider {
  margin: 0;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .item {
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
.dialog_content {
  padding: 15px;
  text-align: left;
  line-height: 40px;

  .top {
    background-color: #f5f5f5;
    padding: 0 10px;
  }
  .box {
    max-height: 300px;
    overflow: auto;
    padding: 0 10px;
  }
  .el-checkbox {
    margin-right: 15px;
  }
}
</style>
